<div class="main-container">
	<h3>Collaborate</h3>

	<div class="main-form lg-view">
		<form [formGroup]="formModel">

			<div class="checkbox-group-container">
				<div class="checkbox-group">
					<mat-checkbox *ngFor="let entity of entityOptions"
						[checked]="entity.id === formModel.get('entityId').value"
						(change)="formModel.get('entityId').setValue(entity.id)" [class.mat-checkbox-disabled]="false"
						[disabled]="entity.id === formModel.get('entityId').value || isLoading">
						{{ entity.name }}</mat-checkbox>
				</div>
			</div>

			<p *ngIf="!isLoadingContacts && !contactOptions?.length">
				There are no available
				{{ formModel.get('entityId').value === RequestUpdateEntity.Assignee ? 'assignees' : 'vendors' }}!
			</p>
			<app-loader *ngIf="isLoadingContacts" [isInline]="true" class="inline"></app-loader>
			<mat-form-field *ngIf="!isLoadingContacts && contactOptions?.length">
				<mat-select formControlName="contact" 
					class="contact-select-dropdown"
					[panelClass]="'contact-select-dropdown'"
					[disabled]="isLoadingContacts || isLoading">
					<mat-select-trigger>
						<div class="contact-container" *ngIf="formModel?.get('contact')?.value">
							<div class="contact-name">
								<span>{{ formModel.get('contact').value.lastName }}, {{
									formModel.get('contact').value.firstName }}</span>
								<span class="contact-title" *ngIf="formModel.get('contact').value?.title">{{
									formModel.get('contact').value.title }}</span>
							</div>
							<div class="contact-details">
								<span class="contact-email">{{ formModel.get('contact').value.emailAddress }}</span>
								<span class="contact-phone">{{ formModel.get('contact').value.phoneNumber }}</span>
							</div>
						</div>
					</mat-select-trigger>
					<mat-option *ngFor="let contact of contactOptions" [value]="contact">
						<div class="contact-container">
							<div class="contact-name">
								<span>{{ contact.lastName }}, {{ contact.firstName }}</span>
								<span class="contact-title" *ngIf="contact.title">{{ contact.title }}</span>
							</div>
							<div class="contact-details">
								<span class="contact-email">{{ contact.emailAddress }}</span>
								<span class="contact-phone">{{ contact.phoneNumber }}</span>
							</div>
						</div>
					</mat-option>
				</mat-select>
			</mat-form-field>

			<div class="checkbox-group-container">
				<div class="checkbox-group">
					<mat-checkbox *ngFor="let type of typeOptions" [checked]="type.id === formModel.get('typeId').value"
						(change)="formModel.get('typeId').setValue(type.id)" [class.mat-checkbox-disabled]="false"
						[disabled]="isTypeControlDisabled(type)">
						{{ type.name }}</mat-checkbox>
				</div>
			</div>

			<div>
				<mat-form-field>
					<mat-label>Comment</mat-label>
					<textarea matInput formControlName="comment" rows="5"
						[disabled]="!formModel.get('contact').value || isLoadingContacts || isLoading"></textarea>
				</mat-form-field>
			</div>
		</form>
	</div>
</div>

<div class="actions-container md-view">
	<ng-container *ngIf="!customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
		<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'../'"></action-button>
		<action-button [icon]="ButtonIcons.Comment" [name]="'Thread'" [subpage]="'thread'"
			*ngIf="pageType === PageType.Customer"></action-button>
		<action-button [icon]="ButtonIcons.People" [name]="'Assignees'" [subpage]="'assignees'"
			*ngIf="pageType === PageType.Customer"></action-button>
		<action-button [icon]="ButtonIcons.Submit" [name]="'Submit'" [clickAction]="submitRequest.bind(self)"
			[disabled]="formModel.invalid"></action-button>
	</ng-container>

	<div class="actions-placeholder-message" *ngIf="customerPreferences.preferences.isNotificationDisabled || customerPreferences.preferences.isJobAutoSkipped">
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
		<span
			*ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.BothDisabled }}</span>
	</div>
</div>